      
<template>
    <div class="container">
        <div >
            <div class="contentTop">
                <img class="bgImg" src="../../assets/imgs/myBg.png" alt="">
                <div class="userInfo">
                    <div class="avatarBox">
                        <div class="avatar" @click="login()">
                            <img class="avatarImg" :src="avatarImgSrc" alt="">
                        </div>
                    </div>
                    <span class="userName" @click="login()">{{userName}}</span>
                </div>
            </div>
            <div class="center">
                <my-info-bar></my-info-bar>
                <div v-for="(item,index) of list" :key="index">
                    <van-cell :title="item.title" is-link @click="handleDialog(item.id)">
                        <template #icon>
                            <img class="icon" :src="item.icon" alt="">
                        </template>
                    </van-cell>
                   <van-divider style="background:rgba(241,241,241,1);margin:0 15px" />
                </div>
            </div>
        </div>
        <tabbar :active="active"></tabbar>
    </div>
</template>

<script>
import tabbar from "@/components/tabbar"
import myInfoBar from "@/components/myInfoBar"
import { Dialog,Toast } from 'vant';
import {mapState} from "vuex"
export default {
    data() {
        return {
            active:"my",
            list:[
                  {id:"1",title:"我的收藏",icon:require("../../assets/icons/shoucang.png")},
                  {id:"2",title:"续保服务",icon:require("../../assets/icons/xubao.png"),itemInfo:{imgsrc:require("../../assets/imgs/xubao2.png"),title:"关爱保险续保服务",subTitle1:"重诺守信",subTitle2:"受益无穷",btnText:"申请续保"}},
                  {id:"3",title:"退保服务",icon:require("../../assets/icons/tuibao.png"),itemInfo:{imgsrc:require("../../assets/imgs/tuibao2.png"),title:"关爱保险退保服务",subTitle1:"关爱传递",subTitle2:"温暖无限",btnText:"退保热线"}},
                  {id:"4",title:"理赔服务",icon:require("../../assets/icons/lipei.png"),itemInfo:{imgsrc:require("../../assets/imgs/lipei2.png"),title:"关爱保险理赔服务",subTitle1:"简单高效",subTitle2:"省心贴心",btnText:"申请理赔"}},
                  {id:"5",title:"客服热线",icon:require("../../assets/icons/kefu.png")},
                  {id:"6",title:"退出登陆",icon:require("../../assets/icons/tuichu.png")},
            ],
        };
    },
    created(){
        document.title="保险商城";
        if(!this.phones){
            this.getPhones();
        }
    },
    methods: {
        handleDialog(id){
            if(!this.token){
                this.$router.push("/login");
                return;
            };
            if(id=="1"){
               this.$router.push({path:'/collection'})
            }else if(id=="5"){
                this.serviceHotline();
            }else if(id=="6"){
                this.logout();
            }else{
                let info=this.list[id-1].itemInfo;
                let phone;
                if(id==2){
                    phone=this.phones.renew_insure_phone;
                }else if(id==3){
                    phone=this.phones.return_insure_phone;
                }else{
                    phone=this.phones.claim_insure_phone;
                }
                this.$router.push({path:"/myDialog",query:{info:info,phone:phone}})
            }
        },
        //客服热线
        serviceHotline(){
            Dialog.confirm({
                title: '客服热线',
                message: '确认要拨打'+this.phones.custom_phone,
            })
            .then(() => {
                console.log("我点击了确认",this.phones.custom_phone);
                window.location.href="tel://"+this.phones.custom_phone;
            })
            .catch(() => {
                 console.log("我点击了取消")
            });
        },
        //退出接口
        logout(){
            Dialog.confirm({
                title: '退出登陆',
                message: '是否确认要退出当前账号？',
            })
            .then(() => {
                this.$https.fetchPost("Login/logout",{},{headers:{"XX-Token":this.token}})
                .then(result=>{
                    console.log(result)
                    if(result.data.code==1){
                        this.$store.commit("LOGOUT");
                        this.$router.replace("/login")
                        Toast("退出成功");
                    }else{
                         Toast(result.data.msg);
                    }
                })
            })
            .catch(() => {
                 console.log("我点击了取消")
            });
        },
        closeMyDialog(){
            this.showMyDialog=false;
        },
        getPhones(){
            this.$https.fetchPost("User/getHotline",{},{headers:{"XX-Token":this.token}})
            .then(result=>{
                let data=result.data;
                // console.log("myInfo页面",data)
                if(data.code==1){
                    this.$store.commit('SET_PHONES',data.data)
                }
            })
        },
        login(){
            if(!this.token){
                this.$router.push("/login");
            }
        },

        
    },
    components:{
        tabbar,
        myInfoBar,
        [Dialog.Component.name]: Dialog.Component,
    },
    watch:{
       
    },
    computed:{
        ...mapState(["phones","userInfo","token"]),
        userName(){
            return !this.token ?  "请登录" : this.userInfo.user_nickname;
        },
        avatarImgSrc(){
            return !this.token ?  require("../../assets/imgs/avatar.png") : this.userInfo.avatar;
        }
    },
}
</script>

<style scoped>
    /* .container{
        width: 100wh;   
        min-height: 100vh;
        background: #fff;
    } */
    .contentTop{
        position: relative;
    }
    .bgImg{
        width: 100%;
    }
    .userInfo{
        position: absolute;
        left: 10%;
        top: 30%;
        display: flex;
        align-items: center;
    }
    .avatarBox{
        width: 65px;
        height: 65px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255,255,255,0.2);
    }
    .avatar{
        width: 56px;
        height: 56px;
        border-radius: 50%;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }
    .avatarImg{
        width: 100%;
        height: 100%;
    }
    .userName{
        font-size:17px;
        color:rgba(255,255,255,1);
        margin-left: 13px;
    }
    .center{
        text-align: start;
        border-radius:10px 10px 0px 0px;
        background:rgba(255,255,255,1);
        margin-top: -10px;
        position: relative;
        overflow: hidden;
        padding: 12px;
    }
    .van-cell{
        color: #666;
        font-size: 13px;
        padding: 13px 8px;
        align-items: center;
    }
    .icon{
        width: 18px;
        height: 19px;
        margin-right: 15px;
        margin-left: 9px;
    }
    .van-cell__right-icon{
        margin-right: 8px;
    }
</style>
<style>
   
</style>


// WEBPACK FOOTER //
// src/views/my/myInfo.vue